import { useEffect, useRef } from "react";

// [id, keys, label]; pages hide the ids they do not support.
const SHORTCUTS = [
  ["next", ["j", "↓"], "Επόμενη εγγραφή"],
  ["prev", ["k", "↑"], "Προηγούμενη εγγραφή"],
  ["open", ["Enter"], "Άνοιγμα στο πλαίσιο"],
  ["page", ["o", "Shift+Enter"], "Άνοιγμα σε πλήρη σελίδα"],
  ["search", ["/"], "Αναζήτηση"],
  ["esc", ["Esc"], "Έξοδος από αναζήτηση / κλείσιμο πλαισίου / καθαρισμός επιλογής"],
  ["select", ["x"], "Επιλογή εγγραφής"],
  ["fav", ["s"], "Σημαντικό"],
  ["recheck", ["r"], "Έλεγχος τώρα"],
  ["pages", ["[", "]"], "Προηγούμενη / επόμενη σελίδα"],
  ["help", ["?"], "Αυτή η λίστα"],
];

const ShortcutsHelp = ({ onClose, hide = [] }) => {
  const closeRef = useRef(null);

  useEffect(() => {
    closeRef.current?.focus();
    const onKey = (e) => {
      if (e.key === "Escape" || e.key === "?") {
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }
    };
    document.addEventListener("keydown", onKey, true);
    return () => document.removeEventListener("keydown", onKey, true);
  }, [onClose]);

  return (
    <div className="ds-modal-backdrop" data-ds-modal-open="true" onMouseDown={onClose}>
      <div
        className="ds-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="ds-shortcuts-title"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="ds-modal-header">
          <h2 id="ds-shortcuts-title">Συντομεύσεις πληκτρολογίου</h2>
          <button ref={closeRef} type="button" className="ds-link-btn" onClick={onClose}>
            Κλείσιμο
          </button>
        </div>
        <dl className="ds-shortcuts">
          {SHORTCUTS.filter(([id]) => !hide.includes(id)).map(([id, keys, label]) => (
            <div key={id} className="ds-shortcut-row">
              <dt>
                {keys.map((k) => (
                  <kbd key={k} className="ds-kbd">
                    {k}
                  </kbd>
                ))}
              </dt>
              <dd>{label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
};

export default ShortcutsHelp;
